import script from "./ReferencedText.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencedText.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__